import apiClient from './apiClient';

/**
 * Obtener todas las notificaciones del usuario autenticado.
 */
export const getNotifications = async () => {
  const response = await apiClient.get('/notifications/');
  return response.data;
};

/**
 * Obtener la cantidad de notificaciones no leídas.
 */
export const getUnreadCount = async () => {
  const response = await apiClient.get('/notifications/unread-count/');
  return response.data.unread_count;
};

/**
 * Marcar una notificación individual como leída.
 */
export const markAsRead = async (notificationId) => {
  const response = await apiClient.post(`/notifications/${notificationId}/read/`);
  return response.data;
};

/**
 * Marcar todas las notificaciones como leídas.
 */
export const markAllAsRead = async () => {
  const response = await apiClient.post('/notifications/read-all/');
  return response.data;
};
